var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.502 60.4405L29.2981 61.8608L31.5361 61.9752L36.3171 61.1929L41.1642 60.0231L48.022 56.4044L55.0618 50.159L56.4243 48.3972L58.8502 44.2914L61.125 40.2927L62.0932 34.6105L62.9412 26.5159L60.3427 19.1647L56.2175 11.4212L50.4907 6.06328L46.1527 3.46601L35.2517 0.418236L23.3005 1.97576L13.8776 6.6204L7.225 12.9316L2.83237 19.228L1.30398 25.0809L0.345979 33.8212L3.638 45.6753L8.10931 52.946L15.967 58.2673L22.502 60.4405Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.03280b5a.svg";
export { ForwardRef as ReactComponent };